<div class="d-flex align-items-start mb-6">
  <label class="col-12 col-lg-4 col-form-label" [class.required]="required">{{ label }}</label>
  <div class="mb-4">
    <!--    <app-chips-legacy-->
    <!--      [chipsList]="chipsListData"-->
    <!--      (dataOutput)="handleDataOutput($event)"-->
    <!--    ></app-chips-legacy>-->
  </div>

  <button type="button" class="btn bg-transparent" (click)="handleOpenModalForm()">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS" class="svg-icon svg-icon-2"></span>
    <span class="text-primary">{{ ctaLabelOpenModalForm }}</span>
  </button>
</div>

<app-modal-form #modalForm [modalConfig]="modalFormConfig">
  <div class="mb-4" *ngIf="listbox_selectedItems.length">
    <app-chips-legacy [chipsList]="listbox_selectedItems" (dataOutput)="handleDataOutput($event)"></app-chips-legacy>
  </div>
  <div class="multiselect-search mb-4">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Silahkan cari {{ searchLabel }} disini" [(ngModel)]="searchKeyword" />
      <span class="input-group-text">
        <span [inlineSVG]="'./assets/media/icons/ic_search.svg'" class="svg-icon svg-icon-2"></span>
      </span>
    </div>
  </div>
  <div class="multiselect-list mh-200px overflow-auto mb-4">
    <div class="form-check my-6 text-capitalize" *ngFor="let item of listbox_listItems | filter : searchKeyword">
      <input class="form-check-input cursor-pointer" type="checkbox" id="flexCheckDefault-{{ item.id }}" (change)="handleChangeSelection()" [(ngModel)]="item.selected" />
      <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">{{ item.name | lowercase }}</label>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-primary" (click)="handleAddChipsList()" [disabled]="!listbox_selectedItems.length">{{ ctaLabelAddItems }}</button>
  </div>
</app-modal-form>
